module.exports = __webpack_public_path__ + "img/HC1024-169.ffac341a.jpg";